// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-col[data-v-6f86f6f0] {\n  border-radius: 4px;\n  margin-left: 20px;\n}\n.el-row[data-v-6f86f6f0] {\n  margin-bottom: 20px;\n}\n.el-tab-pane[data-v-6f86f6f0] {\n  max-height: calc(100vh - 100px);\n  overflow-x: hidden;\n  overflow-y: scroll;\n}", ""]);
// Exports
module.exports = exports;
